import { Button, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";

export const ChangeRate: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();

  return (
    <Grid container padding={2} spacing={2}>
      <Grid item xs={12}>
        <Typography>Change Selected Item Rate and/or Name.</Typography>
        <Divider sx={{ mt: 1, mb: 2 }} /> {/* Divider with spacing around it */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography>Item Rate</Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <WSTextField
          label={""}
          {...register("itemrate")}
          id="itemrate"
          name="itemrate"
          control={control}
          rules={{ required: false }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography>Item Print Name</Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <WSTextField
          label={""}
          {...register("itemname")}
          id="itemname"
          name="itemname"
          control={control}
          rules={{ required: false }}
        />
      </Grid>

      {/* Button in the right corner */}
      <Grid item xs={12}>
        <Grid container justifyContent="flex-end">
          <Button variant="outlined" >
            Apply Selected
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
